module.exports = __webpack_public_path__ + "static/media/L-shape.7562d91a.svg";